<template>
<div class="signup">
  <h1 class="title">{{ $t('common.passwordReset') }}</h1>

  <b-field
    :label="$t('common.email')"
    :type="checkEmpty(errors.email) ? '' : 'is-danger'"
    :message="checkEmpty(errors.email) ? '' : errors.email[0]"
  >
    <b-input
      type="email"
      v-model="email"
      icon="envelope"
      icon-pack="fas"
      @blur="validate('email')"
      :placeholder="$t('common.email')"
    >
    </b-input>
  </b-field>

  <div class="field is-grouped">
    <div class="control">
      <button
        class="button is-link"
        :disabled="hasErrors"
        @click="sendEmail"
      >
        <span class="icon">
          <i class="fas fa-paper-plane"></i>
        </span>
        <span>{{ $t(`msg['Send verification email']`) }}</span>
      </button>
    </div>
  </div>
</div>
</template>
<script>
import { Firebase } from '@/api'
import str from '@/util/str'

export default {
  name: 'PasswordReset',

  components: {
  },

  data () {
    return {
      email: '',
      errors: {},
    }
  },

  computed: {
    hasErrors: function() {
      let hasError = false
      Object.keys(this.errors).map(field => {
        if (this.errors[field].length > 0) hasError = true
      })
      return hasError
    },
  },

  created() {
  },

  methods: {
    async sendEmail() {
      try {
        if (this.hasErrors === true) return
        this.$store.dispatch('setLoading', true)
        const res = await Firebase.sendPasswordResetEmail(this.email)
        this.$store.dispatch('setLoading', false)
        this.$router.push('/password-reset/sent')
      } catch (err) {
        console.log(err);//!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg.sendFailed'))
      }
    },

    keyDownEnter() {
      if (event.keyCode !== 13) return
      this.sendEmail()
    },

    setErrors: function(errors) {
      const keys = Object.keys(this.errors)
      errors.map(err => {
        const field = err.param
        this.initErrors(field)
        this.errors[field].push(err.msg)
      })
    },

    validateAll: function() {
      ['email'].map(field => {
        this.validate(field)
      })
    },

    validate: function(field) {
      const key = 'validate' + str.capitalize(field)
      this[key]()
    },

    validateEmail: function() {
      this.initError('email')
      if (this.checkEmpty(this.email)) this.errors.email.push(this.$t('msg["Email is required"]'))
      if (!str.checkEmail(this.email)) this.errors.email.push(this.$t('msg["Email is not valid"]'))
    },

    initError: function(field) {
      this.$set(this.errors, field, [])
    },

    initErrors: function(field) {
      const keys = Object.keys(this.errors)
      if (!this.inArray(field, keys)) {
        this.initError(field)
      }
    },

    throwReject (err) { return Promise.reject(err) }
  }
}
</script>

